import { Line, LineChart, Tooltip, XAxis, YAxis } from "recharts";
import EllipsisMenu from "../../../../components/EllipsisMenu/EllipsisMenu";
import AnalysisSection from "../AnalysisSection/AnalysisSection";
import { MotionSectionProps } from "./MotionSection.types";
import SkeletonLoadingView from "../../../../components/SkeletonLoadingView/SkeletonLoadingView";

const MotionSection = (props: MotionSectionProps) => {

  const {
    motion,
    width,
    ellipsisMenu
  } = props

  const skeletonLoadingHeight = "5rem"

  const getGraphData = () => {
    if (motion === undefined) { return }
    return motion.delta_x.map((_, i) => {
      return {
        motion_x: motion.delta_x[i],
        motion_y: motion.delta_y[i],
        amt: i
      }
    })
  }

  if (motion === undefined) {
    return (
      <AnalysisSection title="Motion">
        <div className="analysis-section">
          <SkeletonLoadingView style={{height: skeletonLoadingHeight}} />
        </div>
      </AnalysisSection>
    )
  }

  return (
    <AnalysisSection title="Motion" titleChild={
      <EllipsisMenu ellipsisMenu={ellipsisMenu} />
    }>
      <div className="analysis-section">
        <LineChart
          width={width}
          height={100}
          data={getGraphData()}
          margin={{
            top: 0,
            right: 0,
            left: 0,
            bottom: 0,
          }}
        >
          <XAxis dataKey="name" />
          <YAxis domain={[Math.max(...motion?.delta_x ?? []), Math.min(...motion?.delta_y ?? [])]} tick={false} axisLine={false} width={0} />
          <Tooltip />
          {/* <Legend /> */}
          <Line animationDuration={300} type="monotone" dataKey={`motion_x`} stroke={"orange"} dot={false} />
          <Line animationDuration={300} type="monotone" dataKey={`motion_y`} stroke={"pink"} dot={false} />
        </LineChart>
      </div>
    </AnalysisSection>
  )
}

export default MotionSection